import Axios from '../redux/axios';

class SocialAuthService {
  async getRedirectUrl(provider) {
    try {
      const response = await Axios.get(`/auth/${provider}/redirect`);
      return response.data.url;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async handleCallback(provider, code) {
    try {
      const response = await Axios.get(`/auth/${provider}/callback?code=${code}`);
      if (response.data.token) {
        localStorage.setItem('userToken', response.data.token);
        localStorage.setItem('userDetails', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response?.data?.message) {
      return new Error(error.response.data.message);
    }
    return new Error('An error occurred during authentication');
  }
}

export default new SocialAuthService(); 